import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

export const useHash = () => {
  const router = useRouter();
  const [hash, setHash] = useState(router.asPath.split('#')[1] || '');

  useEffect(() => {
    const handleRouteChange = (url: string) => {
      setHash(url.split('#')[1] || '');
    };

    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);

  return hash;
};
